var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m172.5 112.5h15v45h-15z",
    fill: "#9295a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.5 112.5h15v45h-15z",
    fill: "#9295a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 60-30 30 30 30h22.5c4.142 0 7.5-3.358 7.5-7.5v-45c0-4.142-3.358-7.5-7.5-7.5z",
    fill: "#bfcfd6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 67.5v45c0 4.142 3.358 7.5 7.5 7.5h459.5v-60h-459.5c-4.142 0-7.5 3.358-7.5 7.5z",
    fill: "#cde3ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 150h-30v240h30c16.569 0 30-13.431 30-30v-180c0-16.569-13.431-30-30-30z",
    fill: "#ffe880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407 390h-227c-16.569 0-30-13.431-30-30v-180c0-16.569 13.431-30 30-30h227c16.569 0 30 13.431 30 30v7.5l-90 82.5 90 82.5v7.5c0 16.569-13.431 30-30 30z",
    fill: "#fff4d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407 180-75 90 75 90h22.5c4.142 0 7.5-3.358 7.5-7.5v-165c0-4.142-3.358-7.5-7.5-7.5z",
    fill: "#ff513d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 187.5v165c0 4.142 3.358 7.5 7.5 7.5h219.5v-37.5l-30-22.5 30-22.5v-97.5h-219.5c-4.142 0-7.5 3.358-7.5 7.5z",
    fill: "#ff6f4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377 270-30 30 30 30h22.5c4.142 0 7.5-3.358 7.5-7.5v-45c0-4.142-3.358-7.5-7.5-7.5z",
    fill: "#e3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 277.5v45c0 4.142 3.358 7.5 7.5 7.5h159.5v-60h-159.5c-4.142 0-7.5 3.358-7.5 7.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 0-15 30v437l15 30h22.5c4.142 0 7.5-3.358 7.5-7.5v-482c0-4.142-3.358-7.5-7.5-7.5z",
    fill: "#b2bec4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 7.5v482c0 4.142 3.358 7.5 7.5 7.5h22.5v-497h-22.5c-4.142 0-7.5 3.358-7.5 7.5z",
    fill: "#bfcfd6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9295a1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 105,
    r: 7.995
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 75,
    r: 7.995
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.1c6c2ab43b294c1408afcd2d57584737.svg";
export { ForwardRef as ReactComponent };